var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('introduction',{on:{"serve":_vm.serveSite,"scroll":_vm.scrollToItem}}),_c('div',{ref:"projects",staticClass:"projects"},[(_vm.isServed)?_c('projects'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }